import React from 'react';
import PropTypes from 'prop-types';
import DefaultUserImage from './default_user_image.png';
import './ProfileIcon.css';

function ProfileIcon({ url, size, src, border }) {
  src = src || DefaultUserImage;
  border = border || '';

  return (
    <div className={`profile-icon size-${size} ${border}`}>
      {url && (
        <a href={url}>
          <img src={src} alt="Profile" />
        </a>
      )}
      {!url && <img src={src} alt="Profile" />}
    </div>
  );
}

ProfileIcon.propTypes = {
  url: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.number,
  border: PropTypes.string
};

export default ProfileIcon;



// WEBPACK FOOTER //
// ./src/components/ProfileIcon/index.js